import { Charts } from './Charts';
import OccurenceLocationChartsDataProvider from './contexts/OccurenceLocationChartsDataContext';

const OccurenceLocationWrapper = () => {
    return (
        <OccurenceLocationChartsDataProvider>
            <Charts />
        </OccurenceLocationChartsDataProvider>
    );
};

export default OccurenceLocationWrapper;
